export default __webpack_public_path__ + "7937a150285df37c4e54ca731badd0a4.png";